var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MyModal',{attrs:{"name":_vm.modalName,"title":_vm.title,"isRightModal":true,"animation":'modal-right'}},[_c('div',{staticClass:"content-modal",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }